export default import.meta.ROLLDOWN_FILE_URL_FM4ZUAWVNkExmaesQ0KEow